import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import MenuItem from "@mui/material/MenuItem";
import SearchIcon from "@mui/icons-material/Search";
import InputBase from "@mui/material/InputBase";
import { styled } from "@mui/material/styles";
import UseStyle from "../css/styles";
import { Paper } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { KeyboardArrowDown, LogoutOutlined } from "@mui/icons-material";  //FB 8973
import DehazeIcon from "@mui/icons-material/Dehaze";
import { GetAdminSettingValue, GetLogo, InsertPPLogs } from "../api";       //FB 6904
import useMediaQuery from "@mui/material/useMediaQuery";
import { useEffect, useState } from "react";

// Update log
// FB  6192   02/06/2023  DK  Added page to handle header to be displayed
// FB  6904   05/31/2023  DK  Clinical documents not visible on mobile version
// FB  7405   09/21/2023  SK  Orady - Portal changes
// FB  7460   09/25/2023  SK  Ordy Patient Portal issues
// FB  6997   10/09/2023  SK   Patient Portal: All the api's that shows results in the Patient portal needs fine tuning
// FB  8407   03/14/2024  KI   VIP - logo on portal
// FB  8568   04/16/2024  DK  Guardian is not able to see the patient profile details
// FB  8685   05/16/2024  SK   Pay button on portal needs to be greyed out if no callipay
// FB  8973   07/02/2024  DK  Guest login enhancements
// FB  9464   10/08/2024  KI  created new screen for displaying lab orders


export default function Header(props: any) {
  const pages = [""];
  const settings = window.location.href.includes("admin") ? [{ labelName: "Logout", path: "/admin" }] : [
    { labelName: "Profile", path: "/user/home/Profile" },
    { labelName: "Settings", path: "/user/home/Settings" },
    { labelName: "Account Access", path: "/user/register/guardian" },
    { labelName: "Payment", path: "/user/home/MakePayment" },
    { labelName: "Activity Log", path: "/user/home/ActivityLog" },
    { labelName: "Logout", path: "/" }];
  //FB 6904
  const optionsPath = [
    { labelName: "Dashboard", path: "/user/home/dashboard" },
    { labelName: "Appointments", path: "/user/home/appointments" },
    { labelName: "Messages", path: "/user/home/MessageMobileUI" },
    { labelName: "Test Results", path: "/user/home/testresults" },
    { labelName: "Billing", path: "/user/home/Billing" },
    { labelName: "My Record", path: "/user/home/Myrecord" },
    { labelName: "Clinical documents", path: "/user/home/clinicaldocuments" },
    { labelName: "Lab Orderings", path: "/user/home/LabOrdering" }, //FB 9464
  ];
  const [logo, setLogo] = useState("");
  const matches = useMediaQuery("(min-width:600px)");
  const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(
    null
  );
  const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(
    null
  );

  const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };
  const optionMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const Search = styled("div")(({ theme }) => ({
    position: "relative",
    borderRadius: "12px",
    backgroundColor: "#FAF9F6",
    "&:hover": {
      backgroundColor: "#FAF9F6",
    },
    marginLeft: 0,
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(1),
      width: "auto",
    },
    color: "#13607C",
  }));

  const SearchIconWrapper = styled("div")(({ theme }) => ({
    padding: theme.spacing(0, 2),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "black",
  }));

  const StyledInputBase = styled(InputBase)(({ theme }) => ({
    color: "inherit",
    "& .MuiInputBase-input": {
      padding: theme.spacing(1, 1, 1, 0),
      // vertical padding + font size from searchIcon
      paddingLeft: `calc(1em + ${theme.spacing(4)})`,
      transition: theme.transitions.create("width"),
      width: "100%",
      [theme.breakpoints.up("sm")]: {
        width: "12ch",
        "&:focus": {
          width: "20ch",
        },
      },
    },
  }));

  const styles = UseStyle();
  const navigate = useNavigate();
  var user = sessionStorage.getItem("user");
  if (user != null) {
    var isGuardian = JSON.parse(user).IsGuardian;
    user = JSON.parse(user);
  }

  const ViewDashboard = async () => {
    let url = "/";
    let user = sessionStorage.getItem("user");
    if (user != null) {
      if (JSON.parse(user).Employee_n) {
        url = "/admin/home/dashboard"
      } else if (JSON.parse(user).Login) {
        url = "/user/home/dashboard"
      }
    }

    //FB 8973
    if (!(window.location.pathname.toLowerCase() == "/user/guestBilling".toLowerCase()
      || window.location.pathname.toLowerCase() == "/user/guestLogin".toLowerCase()
      || window.location.pathname.toLowerCase() == "/user/guestPayment".toLowerCase())) {
      navigate(url);
    }
    InsertPPLogs("Clicked on Logo", window.location.href, userName, "");
  };

  const handleClick = (path: string, pathname: string) => {
    if (path == "/" || path == "/admin") {
      sessionStorage.removeItem("user");
      //sessionStorage.clear();
    }
    setAnchorElUser(null);
    setAnchorEl(null);
    navigate(path);
    InsertPPLogs(
      "Clicked on " + pathname + " MyAccount",
      window.location.href,
      userName,
      ""
    );
  };
  let patientName = "User";
  let userName: any;
  let data = sessionStorage.getItem("user");
  if (data != null) {
    patientName = JSON.parse(data).PatientFirstName;
    userName = JSON.parse(data).Login;
  }

  //FB 8973
  let guest = "";
  let guestData = sessionStorage.getItem("PatientInfo");
  if (guestData != null) {
    guest = JSON.parse(guestData);
  }

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClose = () => {
    setAnchorEl(null);
  };

  async function GetLogoImage() {
    var img = await GetLogo();
    if (img != null && img != undefined) {
      setLogo(img);
    }
    // else {
    //   setLogo("/Images/IntouchLogo.jpg");
    // }
  }

  //FB 6904
  const [enablebilling, setEnableBilling] = useState(false);
  const [enablecenterLogo, setEnableCenterLogo] = useState(false); //FB 8407
  async function LoadBillingNavLink() {
    let setting = await GetAdminSettingValue("EnableBillingForPortal");
    if (Number(setting) === 1) {
      setEnableBilling(true);
      sessionStorage.setItem("EnableBillingForPortal", "1");//FB 6997
    }
    else {
      setEnableBilling(false);
      sessionStorage.setItem("EnableBillingForPortal", "0");//FB 6997
    }
  }
  const [callipayID, setCallipayID] = React.useState(false);//FB 8685
  //FB 8407
  async function LoadCenterLogo() {
    let setting = await GetAdminSettingValue("EnableCenterLogo");
    //FB 8685 - Begin
    const callipayData = await GetAdminSettingValue("CALLIPAY_API_KEY");
    //CLON-2
    const settingValue = callipayData?.[0];
    setCallipayID(!!settingValue?.trim());
    //FB 8685 - End
    if (Number(setting) === 1) {
      setEnableCenterLogo(true)
    }
    else {
      setEnableCenterLogo(false);
    }
  }

  //FB 8973
  const handleLogout = () => {
    navigate("/user/guestlogin")
    sessionStorage.removeItem("PatientInfo");
  }

  useEffect(() => {
    GetLogoImage();
    LoadBillingNavLink();   //FB 6904
    LoadCenterLogo(); //FB 8407
  }, []);


  return (
    <AppBar
      position="static"
      style={
        matches == false
          ? { background: "none" }
          : { background: "none", paddingLeft: "55px" }
      }
    >
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          {/* FB 8407 start */}
          {enablecenterLogo ? (
            <div style={{ display: 'flex', alignItems: 'center', flexGrow: 1, width: '83%', justifyContent: 'center' }}>
              <img
                src={props.src ? props.src : logo}
                alt="logo"
                style={
                  matches == false
                    ? { width: '93px', height: '40px', cursor: 'pointer' }
                    : { maxWidth: '75vw', cursor: 'pointer' }
                }
                onClick={ViewDashboard}
              />
            </div>
          ) : (
            <img
              src={props.src ? props.src : logo}
              alt="logo"
              style={
                matches == false
                  ? { width: '93px', height: '40px', cursor: 'pointer' }
                  : { maxWidth: '75vw', cursor: 'pointer' }
              }
              onClick={ViewDashboard}
            />
          )}
          {/* FB 8407 end */}
          <Box sx={{ flexGrow: 1, display: { xs: "flex", md: "none" } }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: "block", md: "none" },
              }}
            >
              {pages.map((page) => (
                <MenuItem key={page} onClick={handleCloseNavMenu}>
                  <Typography textAlign="center">{page}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
          <Box sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }}>
            {pages.map((page) => (
              <Button
                key={page}
                onClick={handleCloseNavMenu}
                sx={{ my: 2, color: "white", display: "block" }}
              >
                {page}
              </Button>
            ))}
          </Box>
          <Box
            sx={{
              flexGrow: 0,
              // paddingRight: "30px",
              display: user != null ? "flex" : "none",
            }}
          >
            <Tooltip title="Open settings" style={{ padding: "0px !" }}>
              <Button
                style={{
                  color: "#083A4D",
                  fontWeight: "bold",
                  textTransform: "capitalize",
                }}
                onClick={handleOpenUserMenu}
                startIcon={
                  <Avatar className={styles.Avatar} src="/broken-image.jpg" />
                }
                endIcon={matches && <KeyboardArrowDown />}
              >
                {matches && "My account"}
              </Button>
            </Tooltip>
            {!matches && (
              <button
                onClick={optionMenu}
                style={{
                  padding: "0px !important",
                  margin: "0px !important",
                  background: "none",
                  border: "none",
                  color: "#13607C",
                }}
              >
                <DehazeIcon />
              </button>
            )}

            <Menu
              sx={{ mt: "45px" }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              {/* FB 8568 */}
              {/* FB 8685 */}
              {settings.map((setting, index) =>
                (isGuardian && setting.labelName === "Account Access") ||
                  (!callipayID && setting.labelName === "Payment") ? (
                  null
                ) : (
                  <MenuItem
                    key={index}
                    onClick={() => handleClick(setting.path, setting.labelName)}
                  >
                    <Typography
                      textAlign="center"
                      style={{
                        color: matches == false ? "#13607C" : "",
                      }}
                    >
                      <b style={{ color: "#13607C" }}>{setting.labelName}</b>
                    </Typography>
                  </MenuItem>
                )
              )}

            </Menu>
            <Menu
              id="basic-menu"
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              MenuListProps={{
                "aria-labelledby": "basic-button",
              }}
            >
              {/* FB 6904 */}
              {enablebilling ?
                optionsPath.map((options, index) => (
                  <MenuItem
                    key={index}
                    onClick={() => handleClick(options.path, options.labelName)}
                  >
                    <Typography textAlign="center" style={{ color: "#13607C" }}>
                      <b>{options.labelName}</b>
                    </Typography>
                  </MenuItem>
                )) :
                optionsPath.filter(options => options.labelName != "Billing")
                  .map((options, index) => (
                    <MenuItem
                      key={index}
                      onClick={() => handleClick(options.path, options.labelName)}
                    >
                      <Typography textAlign="center" style={{ color: "#13607C" }}>
                        <b>{options.labelName}</b>
                      </Typography>
                    </MenuItem>
                  ))}
            </Menu>
          </Box>
          {/* FB 8973 */}
          <Box
            sx={{
              flexGrow: 0,
              display: (window.location.pathname.toLowerCase() == "/user/guestBilling".toLowerCase()
                || window.location.pathname.toLowerCase() == "/user/guestPayment".toLowerCase()) ? "flex" : "none",
            }}
          >
            <Tooltip title="Logout" style={{ padding: "0px !" }}>
              <Button
                style={{
                  color: "#083A4D",
                  fontWeight: "bold",
                  textTransform: "capitalize",
                }}
                onClick={handleLogout}
                endIcon={
                  <LogoutOutlined className={styles.Avatar} />
                }
              >
                Logout
              </Button>
            </Tooltip>
          </Box>
          <Paper
            component="form"
            sx={{
              paddingLeft: "4px",
              display: "flex",
              alignItems: "center",
              background: "#E8E9E9",
              borderRadius: "8px",
            }}
          ></Paper>
        </Toolbar>
      </Container>
      {/* FB 7405 - Removed Unused Part Of Code */}
    </AppBar>
  );
}
